import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { ArrowLeft, ChevronRight } from "lucide-react";
import api from "@/lib/api";

// "Back to session" + "Next player" shortcuts while working through a session's players.
export const SessionPlayerNav = ({ offeringId, currentStudentId, refreshKey, compact }) => {
  const [s, setS] = useState(null);
  useEffect(() => {
    if (!offeringId) return;
    api.get(`/offerings/${offeringId}/detail`).then((r) => setS(r.data)).catch(() => setS(null));
  }, [offeringId, refreshKey]);
  if (!offeringId || !s) return null;
  const next = (s.roster || []).find((p) => p.booking_id && !p.resolution && p.id !== currentStudentId);
  return (
    <div className={`flex flex-wrap items-center gap-2 ${compact ? "" : "card-surface p-3 mb-4"}`} data-testid="session-player-nav">
      <Link to={`/offerings/${offeringId}`} className="text-[10px] uppercase tracking-wider px-3 py-1.5 border border-[#404040] hover:border-white inline-flex items-center gap-1" data-testid="nav-back-to-session">
        <ArrowLeft className="w-3 h-3" /> Back to session
      </Link>
      {next ? (
        <Link to={`/coach/feedback?booking=${next.booking_id}&student=${next.id}&from=${offeringId}`} reloadDocument
          className="text-[10px] uppercase tracking-wider px-3 py-1.5 bg-[#CCFF00] text-black font-bold inline-flex items-center gap-1" data-testid="nav-next-player">
          Next player: {next.name} <ChevronRight className="w-3 h-3" />
        </Link>
      ) : (
        <span className="text-[10px] uppercase tracking-wider text-[#737373]" data-testid="nav-no-next">No other players waiting</span>
      )}
      {!compact && <span className="text-xs text-[#737373] ml-auto">{s.title}</span>}
    </div>
  );
};
